import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { SiFlutter, SiKotlin } from "react-icons/si";
import { TbBrandReactNative } from "react-icons/tb";
import { FaApple } from "react-icons/fa";

const Header = () => {
    const [mobileMenu, setMobileMenu] = useState(false);
    const [mobileTechOpen, setMobileTechOpen] = useState(false);

    const [showDropdown, setShowDropdown] = useState(false);


    const dropdownItemStyle = ({ isActive }) => ({
        display: "block",
        padding: "10px 15px",
        textDecoration: "none",
        color: isActive ? "#E8212A" : "#333",
        fontWeight: isActive ? "700" : "500",
        backgroundColor: isActive ? "#FFF5F5" : "transparent",
        transition: "all 0.3s ease",
    });

    const navLinkStyle = ({ isActive }) => ({
        textDecoration: "none",
        color: isActive ? "#E8212A" : "#222",
        fontWeight: isActive ? "700" : "500",
        position: "relative",
        paddingBottom: "5px",
        borderBottom: isActive ? "2px solid #E8212A" : "2px solid transparent",
        transition: "all 0.3s ease",
    });

    return (
        <>
            <header
                className="headercss"
                style={{
                    background: "#fff",
                    borderBottom: "1px solid #f1f1f1",
                    position: "sticky",
                    top: 0,
                    zIndex: 999,
                    backdropFilter: "blur(10px)",
                    animation: "fadeSlideDown .55s both",
                }}
            >
                {/* Background Grid */}
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        pointerEvents: "none",
                        opacity: 0.5,
                    }}
                >
                    <svg width="100%" height="100%">
                        <defs>
                            <pattern
                                id="grid"
                                x="0"
                                y="0"
                                width="32"
                                height="32"
                                patternUnits="userSpaceOnUse"
                            >
                                <rect
                                    x="0"
                                    y="0"
                                    width="1"
                                    height="1"
                                    fill="#E8212A"
                                    opacity=".08"
                                />
                            </pattern>
                        </defs>

                        <rect width="100%" height="100%" fill="url(#grid)" />
                    </svg>
                </div>

                {/* Main Header */}
                <div
                    style={{
                        maxWidth: "1440px",
                        margin: "0 auto",
                        padding: "0 22px",
                        height: "78px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        position: "relative",
                        zIndex: 5,
                    }}
                >
                    {/* Logo */}
                    <NavLink
                        to="/"
                        style={{
                            textDecoration: "none",
                            flexShrink: 0,
                        }}
                    >
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "12px",
                            }}
                        >
                            <div
                                style={{
                                    background: "#fff",
                                    borderRadius: "16px",
                                    padding: "6px",
                                    boxShadow:
                                        "0 10px 30px rgba(232,33,42,.14)",
                                    border: "1px solid rgba(232,33,42,.12)",
                                    transition: "all .35s ease",
                                }}
                            >
                                <svg
                                    width="38"
                                    height="38"
                                    viewBox="0 0 80 80"
                                    fill="none"
                                >
                                    <path
                                        d="M18 58L40 18L62 58L53 58L40 32L27 58Z"
                                        fill="#111"
                                    />

                                    <path
                                        d="M27 45L53 45L50 52L30 52Z"
                                        fill="#111"
                                    />

                                    <rect
                                        x="46"
                                        y="16"
                                        width="5"
                                        height="5"
                                        rx="1.2"
                                        fill="#E8212A"
                                    />

                                    <rect
                                        x="53"
                                        y="10"
                                        width="4"
                                        height="4"
                                        rx="1"
                                        fill="#E8212A"
                                    />

                                    <rect
                                        x="61"
                                        y="15"
                                        width="3"
                                        height="3"
                                        rx="1"
                                        fill="#E8212A"
                                    />

                                    <ellipse
                                        cx="58"
                                        cy="52"
                                        rx="16"
                                        ry="8"
                                        stroke="#E8212A"
                                        strokeWidth="2.5"
                                        fill="none"
                                    />

                                    <circle
                                        cx="66"
                                        cy="45"
                                        r="3.5"
                                        fill="#E8212A"
                                    />
                                </svg>
                            </div>

                            <div>
                                <div
                                    style={{
                                        fontFamily: "'Syne',sans-serif",
                                        fontWeight: 800,
                                        fontSize: "clamp(12px, 2vw, 20px)",
                                        color: "#111",
                                        lineHeight: 1,
                                        letterSpacing: "-.5px",
                                    }}
                                >
                                    AppVerse
                                    <span style={{ color: "#E8212A" }}>
                                        Labs
                                    </span>
                                </div>

                                <div
                                    style={{
                                        fontFamily:
                                            "'Plus Jakarta Sans',sans-serif",
                                        fontSize: "clamp(8px, 2vw, 10px)",
                                        color: "#999",
                                        marginTop: "4px",
                                        letterSpacing: "2px",
                                        textTransform: "uppercase",
                                    }}
                                >
                                    App Development Studio
                                </div>
                            </div>
                        </div>
                    </NavLink>

                    {/* Desktop Nav */}
                    <nav className="desktop-nav">
                        <NavLink to="/IOSApp" style={navLinkStyle}>
                            iOS Apps
                        </NavLink>

                        <NavLink to="/Androidapps" style={navLinkStyle}>
                            Android Apps
                        </NavLink>

                        <div
                            style={{ position: "relative", display: "inline-block" }}
                            onMouseEnter={() => setShowDropdown(true)}
                            onMouseLeave={() => setShowDropdown(false)}
                        >
                            <NavLink to="/Technologie" style={navLinkStyle}>
                                Technologies ▼
                            </NavLink>

                          {showDropdown && (
    <div
        className="tech-dropdown-wrapper"
        onMouseEnter={() => setShowDropdown(true)}
        onMouseLeave={() => setShowDropdown(false)}
    >
        <div className={`tech-dropdown ${showDropdown ? "show" : ""}`}>

            <NavLink
                to="/Technologie/flutter"
                className="dropdown-item"
            >
                <span className="icon">
                    <SiFlutter />
                </span>

                <div>
                    <h6>Flutter</h6>
                    <small>Cross Platform Apps</small>
                </div>
            </NavLink>

            <NavLink
                to="/Technologie/ReactNative"
                className="dropdown-item"
            >
                <span className="icon">
                    <TbBrandReactNative />
                </span>

                <div>
                    <h6>React Native</h6>
                    <small>Native Experience</small>
                </div>
            </NavLink>

            <NavLink
                to="/Technologie/Kotlin"
                className="dropdown-item"
            >
                <span className="icon">
                    <SiKotlin />
                </span>

                <div>
                    <h6>Kotlin</h6>
                    <small>Android Development</small>
                </div>
            </NavLink>

            <NavLink
                to="/Technologie/Swift"
                className="dropdown-item"
            >
                <span className="icon">
                    <FaApple />
                </span>

                <div>
                    <h6>Swift</h6>
                    <small>iOS Development</small>
                </div>
            </NavLink>

        </div>
    </div>
)}
                        </div>


                        <NavLink to="/Portfolio" style={navLinkStyle}>
                            Portfolio
                        </NavLink>
                        <NavLink to="/Contactus" style={navLinkStyle}>
                            Contact Us
                        </NavLink>
                        <NavLink to="/Contactus" style={navLinkStyle}>
                            <a
                                href="#"
                                className="header-btn header-button"
                            >
                                Build Your App →
                            </a>

                        </NavLink>
                    </nav>

                    {/* Mobile Toggle */}
                    <button
                        onClick={() => setMobileMenu(!mobileMenu)}
                        className="mobile-menu-btn"
                    >
                        {mobileMenu ? <X size={26} /> : <Menu size={26} />}
                    </button>
                </div>

                {/* Mobile Menu */}
                <div className={`mobile-menu ${mobileMenu ? "active" : ""}`}>

                    <NavLink
                        to="/IOSApp"
                        onClick={() => setMobileMenu(false)}
                    >
                        iOS Apps
                    </NavLink>

                    <NavLink
                        to="/Androidapps"
                        onClick={() => setMobileMenu(false)}
                    >
                        Android Apps
                    </NavLink>

                    {/* Technology Accordion */}
                    <div className="mobile-tech-wrapper">
                        <button
                            className="mobile-tech-btn"
                            onClick={() => setMobileTechOpen(!mobileTechOpen)}
                        >
                            <span>Technologies</span>
                            <span className={mobileTechOpen ? "rotate-arrow" : ""}>
                                ▼
                            </span>
                        </button>

                   <div
    className={`mobile-tech-dropdown ${
        mobileTechOpen ? "show" : ""
    }`}
>
    <NavLink
        to="/Technologie/flutter"
        onClick={() => {
            setMobileMenu(false);
            setMobileTechOpen(false);
        }}
    >
        <SiFlutter className="mobile-tech-icon" />
        Flutter
    </NavLink>

    <NavLink
        to="/Technologie/ReactNative"
        onClick={() => {
            setMobileMenu(false);
            setMobileTechOpen(false);
        }}
    >
        <TbBrandReactNative className="mobile-tech-icon" />
        React Native
    </NavLink>

    <NavLink
        to="/Technologie/Kotlin"
        onClick={() => {
            setMobileMenu(false);
            setMobileTechOpen(false);
        }}
    >
        <SiKotlin className="mobile-tech-icon" />
        Kotlin
    </NavLink>

    <NavLink
        to="/Technologie/Swift"
        onClick={() => {
            setMobileMenu(false);
            setMobileTechOpen(false);
        }}
    >
        <FaApple className="mobile-tech-icon" />
        Swift
    </NavLink>
</div>
                    </div>

                    <NavLink
                        to="/Portfolio"
                        onClick={() => setMobileMenu(false)}
                    >
                        Portfolio
                    </NavLink>

                    <NavLink
                        to="/Contactus"
                        onClick={() => setMobileMenu(false)}
                    >
                        Contact Us
                    </NavLink>

                    <NavLink
                        to="/Contactus"
                        className="mobile-cta"
                        onClick={() => setMobileMenu(false)}
                    >
                        Build Your App →
                    </NavLink>

                </div>

                {/* Tech Ticker */}
                <div className="ticker-wrap">
                    <div className="ticker">
                        <span>
                            React Native · Flutter · Swift · Kotlin · Node.js ·
                            Firebase · AWS · GraphQL · TypeScript · Expo ·
                            Next.js · Supabase
                        </span>

                        <span>
                            React Native · Flutter · Swift · Kotlin · Node.js ·
                            Firebase · AWS · GraphQL · TypeScript · Expo ·
                            Next.js · Supabase
                        </span>
                    </div>
                </div>
            </header>

            {/* CSS */}
            <style>{`
            
            .desktop-nav{
                display:flex;
                align-items:center;
                gap:34px;
                align-items: baseline;
            }

            .desktop-nav a:hover{
                color:#E8212A !important;
            }

            .header-btn{
                background:linear-gradient(135deg,#E8212A,#ff4d55);
                color:#fff !important;
                padding:14px 22px !important;
                border-radius:14px;
                text-decoration:none;
                font-family:'Plus Jakarta Sans',sans-serif;
                font-size:14px;
                font-weight:700;
                box-shadow:0 12px 30px rgba(232,33,42,.18);
                transition:all .35s ease;
            }

            .header-btn:hover{
                transform:translateY(-3px);
                box-shadow:0 18px 40px rgba(232,33,42,.25);
            }

            .header-btn.header-button:hover{
    color: #fffdfd !important;
}

            .mobile-menu-btn{
                display:none;
                background:#fff;
                border:none;
                width:48px;
                height:48px;
                border-radius:14px;
                align-items:center;
                justify-content:center;
                box-shadow:0 8px 25px rgba(0,0,0,.08);
                cursor:pointer;
            }

            .mobile-menu{
                display:none;
                flex-direction:column;
                gap:18px;
                padding:24px;
                background:#fff;
                border-top:1px solid #f2f2f2;
                animation:fadeIn .35s ease;
            }

            .mobile-menu a{
                text-decoration:none;
                color:#111;
                font-family:'Plus Jakarta Sans',sans-serif;
                font-weight:600;
                font-size:16px;
            }

            .mobile-cta{
                margin-top:8px;
                background:linear-gradient(135deg,#E8212A,#ff4d55);
                color:#fff !important;
                padding:14px 18px;
                border-radius:14px;
                text-align:center;
            }

            .mobile-menu.active{
                display:flex;
            }

            .ticker-wrap{
                background:#fafafa;
                border-top:1px solid #f2f2f2;
                overflow:hidden;
                padding:9px 0;
            }

            .ticker{
                display:flex;
                gap:60px;
                width:max-content;
                animation:scrollTicker 24s linear infinite;
            }

            .ticker span{
                font-family:'Plus Jakarta Sans',sans-serif;
                font-size:11px;
                letter-spacing:2px;
                color:#999;
                text-transform:uppercase;
                white-space:nowrap;
            }

            @keyframes scrollTicker{
                from{
                    transform:translateX(0);
                }
                to{
                    transform:translateX(-50%);
                }
            }

            @keyframes fadeSlideDown{
                from{
                    opacity:0;
                    transform:translateY(-20px);
                }
                to{
                    opacity:1;
                    transform:translateY(0);
                }
            }

            @keyframes fadeIn{
                from{
                    opacity:0;
                }
                to{
                    opacity:1;
                }
            }

            @media(max-width:1100px){

                .desktop-nav{
                    gap:22px;
                }

                .desktop-nav a{
                    font-size:13px !important;
                }

                .header-btn{
                    padding:12px 18px !important;
                }
            }

            @media(max-width:920px){

                .desktop-nav{
                    display:none;
                }

                .mobile-menu-btn{
                    display:flex;
                }

                .ticker span{
                    font-size:10px;
                }
            }

            @media(max-width:600px){

                .headercss{
                    border-bottom:1px solid #f3f3f3;
                }

                .ticker-wrap{
                    display:none;
                }

                .mobile-menu{
                    padding:20px;
                }

                .mobile-menu a{
                    font-size:15px;
                }

            }
.mobile-tech-dropdown a{
    display:flex;
    align-items:center;
    gap:12px;
}

.mobile-tech-icon{
    font-size:20px;
    color:#E8212A;
    flex-shrink:0;
}.mobile-tech-icon{
    width:34px;
    height:34px;

    display:flex;
    align-items:center;
    justify-content:center;

    padding:8px;
    border-radius:10px;

    background:rgba(232,33,42,.1);
    color:#E8212A;
}
            .tech-dropdown-wrapper {
  position: relative;
  display: inline-flex;
  align-items: center;
}

.dropdown-arrow {
  margin-left: 6px;
  font-size: 10px;
  transition: 0.3s ease;
}

.dropdown-arrow.rotate {
  transform: rotate(180deg);
}

.tech-dropdown {
  position: absolute;
  top: 14px;
  left: 50%;
  transform: translateX(-50%) translateY(15px);
  width: 280px;
  background: rgba(255,255,255,0.95);
  backdrop-filter: blur(20px);
  border-radius: 20px;
  padding: 10px;
  box-shadow:
      0 20px 50px rgba(0,0,0,0.15),
      0 5px 20px rgba(232,33,42,0.12);
  border: 1px solid rgba(255,255,255,0.5);
  opacity: 0;
  visibility: hidden;
  transition: all .35s ease;
  z-index: 9999;
}

.tech-dropdown.show {
  opacity: 1;
  visibility: visible;
  transform: translateX(-50%) translateY(0);
}

.tech-dropdown::before {
  content: "";
  position: absolute;
  top: -8px;
  left: 50%;
  width: 16px;
  height: 16px;
  background: white;
  transform: translateX(-50%) rotate(45deg);
  border-radius: 3px;
}

.dropdown-item {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px 16px;
  border-radius: 14px;
  text-decoration: none;
  transition: all .3s ease;
  color: #222;
  margin-bottom: 4px;
}

.dropdown-item:last-child {
  margin-bottom: 0;
}

.dropdown-item:hover {
  background: linear-gradient(
    135deg,
    rgba(232,33,42,.08),
    rgba(232,33,42,.15)
  );
  transform: translateX(5px);
}

.dropdown-item .icon {
  width: 45px;
  height: 45px;
  border-radius: 12px;
  background: linear-gradient(
    135deg,
    #ff4d4d,
    #e8212a
  );
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  color: white;
  box-shadow: 0 8px 18px rgba(232,33,42,.25);
}

.dropdown-item h6 {
  margin: 0;
  font-size: 15px;
  font-weight: 700;
  color: #111;
}

.dropdown-item small {
  color: #777;
  font-size: 12px;
}

.dropdown-item.active {
  background: rgba(232,33,42,.08);
}

.dropdown-item.active h6 {
  color: #e8212a;
}
.mobile-menu {
  position: fixed;
  top: 70px;
  left: -100%;
      overflow-x: hidden;
  width: 85%;
  max-width: 340px;
  height: calc(100vh - 70px);
  background: #ffffff;
  z-index: 9999;
  transition: all .4s ease;
  padding: 30px 25px;
  overflow-y: auto;
  box-shadow: 20px 0 50px rgba(0,0,0,0.08);
}

.mobile-menu.active {
  left: 0;
}

.mobile-menu a {
  display: flex;
  align-items: center;
  text-decoration: none;
  color: #111;
  font-size: 18px;
  font-weight: 600;
  padding: 15px 18px;
  border-radius: 14px;
  margin-bottom: 8px;
  transition: all .3s ease;
}

.mobile-menu a:hover,
.mobile-menu a.active {
  background: rgba(232,33,42,0.08);
  color: #E8212A;
  transform: translateX(6px);
}

.mobile-menu a.active::before {
  content: "";
  width: 4px;
  height: 22px;
  background: #E8212A;
  border-radius: 20px;
  margin-right: 12px;
}

.mobile-tech-wrapper {
  margin-bottom: 10px;
}

.mobile-tech-btn {
  width: 100%;
  border: none;
  background: transparent;
  padding: 15px 18px;
  border-radius: 14px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 18px;
  font-weight: 600;
  color: #111;
  cursor: pointer;
  transition: .3s ease;
}

.mobile-tech-btn:hover {
  background: rgba(232,33,42,0.08);
  color: #E8212A;
}

.mobile-tech-dropdown {
  max-height: 0;
  overflow: hidden;
  transition: all .4s ease;
  margin-left: 15px;
}

.mobile-tech-dropdown.show {
  max-height: 500px;
}

.mobile-tech-dropdown a {
  font-size: 16px;
  font-weight: 500;
  color: #555;
  background: #f8f8f8;
  margin: 6px 0;
  padding: 14px 16px;
}

.mobile-tech-dropdown a:hover {
  background: rgba(232,33,42,0.08);
  color: #E8212A;
}

.rotate-arrow {
  transform: rotate(180deg);
}

.mobile-tech-btn span:last-child {
  transition: .3s ease;
}

.mobile-cta {
  margin-top: 25px !important;
  background: linear-gradient(
    135deg,
    #ff5b5b,
    #E8212A
  ) !important;
  color: white !important;
  justify-content: center;
  border-radius: 50px !important;
  padding: 16px 20px !important;
  font-weight: 700 !important;
  box-shadow: 0 15px 35px rgba(232,33,42,.25);
}

.mobile-cta:hover {
  transform: translateY(-3px) !important;
  background: linear-gradient(
    135deg,
    #ff6b6b,
    #ff2d2d
  ) !important;
}

.mobile-menu::-webkit-scrollbar {
  width: 4px;
}

.mobile-menu::-webkit-scrollbar-thumb {
  background: rgba(232,33,42,.3);
  border-radius: 10px;
}.mobile-menu::before {
  content: "";
  position: absolute;
  top: -120px;
  right: -120px;
  width: 250px;
  height: 250px;
  background: rgba(232,33,42,0.06);
  border-radius: 50%;
  pointer-events: none;
}

.mobile-menu::after {
  content: "";
  position: absolute;
  bottom: -100px;
  left: -100px;
  width: 220px;
  height: 220px;
  background: rgba(232,33,42,0.04);
  border-radius: 50%;
  pointer-events: none;
}
            `}</style>
        </>
    );
};

export default Header;